import React, { useEffect, useState } from 'react';
import styles from '../styles/survey.module.css';
import quotStart from '../../../assets/suvreyImages/surveyIcons/quotStart.png';
import quotEnd from '../../../assets/suvreyImages/surveyIcons/quotEnd.png';
import { useLocation } from "react-router-dom";
import { SurveyServices } from '../services/SurveyServices';


const FeaturesCarousell = ({ featuresArray, endSurvey }) => {
    const location = useLocation();
    const [slideIndex, setSlideIndex] = useState(0);
    const [familyLink, setFamilyLink] = useState('');
    const afterPaymentSurveyFlag = location.state.afterPaymentSurveyFlag;


    const switchNextSlide = () => {
        if (slideIndex < featuresArray.length - 1) {
            setSlideIndex(slideIndex + 1);
        }
    }

    const swithPreviousSlide = () => {
        if (slideIndex > 0) {
            setSlideIndex(slideIndex - 1);
        }
    }

    useEffect(() => {
        if (afterPaymentSurveyFlag) {
            setFamilyLink('/family');
        }
    }, [afterPaymentSurveyFlag]);

    const sendEndSurveyEvent = () => {
        window.dataLayer.push({
            event: 'endSurvey',
            eventProps: {
                label: "End Survey",
            }
        });
    }

    return (
        <>
            <div className={styles.featureContainer} key={featuresArray[slideIndex].id}>
                <div className={styles.featureImageContainer}>
                    <img src={SurveyServices.GetFeatureImageUrl(featuresArray[slideIndex].appImage)} alt='defaultFeatureImage' className={styles.featureMainImage} />
                </div>
                <div className={styles.featureTextContainer}>
                    <h4 className={styles.featureTitle}>{featuresArray[slideIndex].title}</h4>
                    <p className={styles.description}>{featuresArray[slideIndex].description}</p>
                    <div className={styles.testimonialBox}>
                        <div>
                            <img src={SurveyServices.GetFeatureAvatarUrl(featuresArray[slideIndex].image)} alt="" className={styles.testimonialImage} />
                        </div>
                        <p className={styles.featureTestimonial}>
                            <img src={quotStart} alt='quotImage' className={styles.quotStart} />
                            {featuresArray[slideIndex].quote}
                            <img src={quotEnd} alt='quotImage' className={styles.quotEnd} />
                        </p>
                    </div>
                    <div className={styles.buttonContainer}>
                        {slideIndex < featuresArray.length - 1 ?
                            <div className={styles.featureNavigation}>
                                {slideIndex > 0 && <button className={styles.startTrackingButton} onClick={swithPreviousSlide}>Back</button>}
                                <button className={styles.startTrackingButton} onClick={switchNextSlide}>Next</button>
                            </div>
                            : <>
                                {
                                    familyLink ?
                                        <a href={familyLink} className={styles.startTrackingButton} onClick={sendEndSurveyEvent}>Start Tracking Now</a> :
                                        <a href='/packages' className={styles.startTrackingButton} onClick={sendEndSurveyEvent}>Start Tracking Now</a>
                                }
                            </>

                        }

                    </div>
                </div>
            </div >
        </>

    )
}

export default FeaturesCarousell